export default "__VITE_ASSET__a1a94419__"